import React from "react";
import { LoginLayout } from "../components";
import { ThankYou } from "../features/auth";

const ThankYouPage = () => {
  return (
    <LoginLayout>
      <ThankYou />
    </LoginLayout>
  );
};

export default ThankYouPage;
